import React from 'react';

import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { PartnerBadge } from '@sravni/react-ugc/lib/PartnerBadge';

import { Logo } from '@components/RatingTable/columns/components/Logo/Logo';

import type { CellContext } from '@tanstack/table-core';

import type { RatingItem } from '../../../types/rating';

export const makeOrganizationNameColumn = <T extends RatingItem>(info: CellContext<T, any>) => {
  const { organizationName, organizationLogo, isPartner } = info.row.original;

  const logo = <Logo link={organizationLogo} />;

  return (
    <Space size={8} direction="horizontal" align="center">
      {isPartner ? <PartnerBadge>{logo}</PartnerBadge> : logo}
      <Text size={14} strong>
        {organizationName}
      </Text>
    </Space>
  );
};
